export default {
  RESERVE_PRICE_PRIMARY_ANCHOR_REQUIRED: 'RESERVE_PRICE_PRIMARY_ANCHOR_REQUIRED',
  RESERVE_PRICE_MULTIPLIER_REQUIRED: 'RESERVE_PRICE_MULTIPLIER_REQUIRED',
  RESERVE_PRICE_SHELF_LIFE_REQUIRED: 'RESERVE_PRICE_SHELF_LIFE_REQUIRED',
  RESERVE_PRICE_OVERLAPPING_BRACKETS: 'RESERVE_PRICE_OVERLAPPING_BRACKETS',
  RESERVE_PRICE_EXCEPTION_OVERLAPPING_BRACKETS: 'RESERVE_PRICE_EXCEPTION_OVERLAPPING_BRACKETS',
  RESERVE_PRICE_SHELF_LIFE_GAPS: 'RESERVE_PRICE_SHELF_LIFE_GAPS',
  RESERVE_PRICE_EXCEPTION_BRACKETS_REQUIRED: 'RESERVE_PRICE_EXCEPTION_BRACKETS_REQUIRED',
  RESERVE_PRICE_SHELF_LIFE_NOT_COVERED: 'RESERVE_PRICE_SHELF_LIFE_NOT_COVERED',
  NO_RESERVE_PRICE_OPTIONS: {
    code: 'NO_RESERVE_PRICE_OPTIONS',
    message: 'No options available for this exception parameter. Please select a different parameter.',
  },
};
